export enum KeyCode {
  arrowDown = 'ArrowDown',
  arrowUp = 'ArrowUp',
  enter = 'Enter',
  escape = 'Escape',
  space = 'Space',
}
